<template>
  <v-card flat class="pa-3 mb-4">
    <v-row>
      <v-col cols="12" md="2">
        <v-select
            v-model="filters.booking_type"
            :items="booking_types"
            label="Tipo di prenotazione"
            item-value="value"
            item-text="name"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-select
            v-model="filters.sport_id"
            :items="sortedSports"
            label="Sport"
            item-value="_id"
            item-text="name"
            multiple
            clearable
        />
      </v-col>

      <v-col cols="12" md="2">
        <v-select
            v-model="filters.center_id"
            :items="centers"
            label="Centro"
            item-value="_id"
            item-text="desc"
            multiple
            clearable
        />
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
            v-model="filters.user_id"
            :items="userOptions"
            item-value="_id"
            item-text="label"
            label="Utente"
            :loading="userLoading"
            :search-input.sync="userSearch"
            :menu-props="{ maxHeight: '300px' }"
            no-data-text="Nessun utente trovato"
            hide-no-data
            clearable
        />

      </v-col>

      <v-col cols="12" md="2">
        <v-text-field
            label="Cerca per città"
            ref="cityInput"
            v-model="cityLabel"
            clearable
            placeholder=""
        />
      </v-col>

      <v-col cols="12" md="1">
      <v-select
          v-model="filters.radius_km"
          :items="[2, 5, 10, 20, 50, 100]"
          label="Raggio (km)"
      />
      </v-col>
      <v-col cols="12" md="2">
        <v-select
            v-model="quickDate"
            :items="quickOptions"
            label="Periodo"
            @change="onQuickDateSelect"
            clearable
        />
      </v-col>

      <v-col cols="6" md="2" v-if="quickDate === 'custom'">
        <v-menu ref="fromMenu" v-model="fromMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="formattedFrom" label="Da" readonly v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="filters.from" @input="fromMenu = false" />
        </v-menu>
      </v-col>

      <v-col cols="6" md="2" v-if="quickDate === 'custom'">
        <v-menu ref="toMenu" v-model="toMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="formattedTo" label="A" readonly v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="filters.to" @input="toMenu = false" />
        </v-menu>
      </v-col>
    </v-row>

    <v-btn @click="emitFilters" color="primary" class="mt-2">Applica filtri</v-btn>
    <v-btn @click="resetFilters" color="grey lighten-1" class="ml-2 mt-2">
      Reset
    </v-btn>
  </v-card>
</template>

<script>
import moment from 'moment';

export default {
  name: 'FilterPanel',
  props: {
    sports: Array,
    centers: Array
  },
  data() {
    return {
      cityLabel: '',
      cityAutocomplete: null,
      userSearch: '',
      userOptions: [],
      userLoading: false,
      userSearchDebounce: null,
      centerSearch: '',
      filters: {
        booking_type: 'all',
        sport_id: [],
        center_id: [],
        from: null,
        to: null,
        user_id: null,
        lat: null,
        lng: null,
        radius_km: 2
      },
      fromMenu: false,
      toMenu: false,
      quickDate: 'last30',
      quickOptions: [
        { text: 'Oggi', value: 'today' },
        { text: 'Ieri', value: 'yesterday' },
        { text: 'Ultima settimana', value: 'last7' },
        { text: 'Ultimi 30 giorni', value: 'last30' },
        { text: 'Ultimi 3 mesi', value: 'last90' },
        { text: 'Ultimo anno', value: 'last365' },
        { text: 'Ultimi 2 anni', value: 'last2years' },
        { text: 'Range personalizzato', value: 'custom' }
      ],
      booking_types: [
        {name: 'Tutte', value: 'all'},
        {name: 'Online', value: 'online'},
        {name: 'Promo SA', value: 'promosa'},
        {name: 'Manuali', value: 'manuali'},
      ],
      users: []
    };
  },
  computed: {
    sortedSports() {
      return [...this.sports].sort((a, b) => a.name.localeCompare(b.name));
    },
    formattedFrom() {
      return this.filters.from ? moment(this.filters.from).format('DD/MM/YYYY') : '';
    },
    formattedTo() {
      return this.filters.to ? moment(this.filters.to).format('DD/MM/YYYY') : '';
    }
  },
  methods: {
    emitFilters() {
      if (this.quickDate !== null && this.filters.from === null && this.filters.to === null) {
        this.onQuickDateSelect(this.quickDate);
      }

      const cleanFilters = {};

      Object.keys(this.filters).forEach(k => {
        const value = this.filters[k];
        if (value) {
          if (k === 'from' || k === 'to') {
            cleanFilters[k] = new Date(value).getTime(); // timestamp in ms
          } else {
            cleanFilters[k] = value;
          }
        }
      });

      this.$emit('filter', cleanFilters);
    },
    resetFilters() {
      this.cityLabel = ''
      this.filters = {
        sport_id: [],
        center_id: [],
        from: null,
        to: null,
        user_id: null,
        booking_type: 'all',
        lat: null,
        lng: null,
        radius_km: 2
      };

      this.quickDate = 'last30';
      this.onQuickDateSelect(this.quickDate);
      const cleanFilters = {};

      Object.keys(this.filters).forEach(k => {
        const value = this.filters[k];
        if (value) {
          if (k === 'from' || k === 'to') {
            cleanFilters[k] = new Date(value).getTime(); // timestamp in ms
          } else {
            cleanFilters[k] = value;
          }
        }
      });
      this.$emit('filter', cleanFilters);
    },
    onQuickDateSelect(value) {
      const today = moment().startOf('day');
      switch (value) {
        case 'today':
          this.filters.from = today.toDate();
          this.filters.to = today.toDate();
          break;
        case 'yesterday':
          this.filters.from = today.clone().subtract(1, 'day').toDate();
          this.filters.to = today.clone().subtract(1, 'day').toDate();
          break;
        case 'last7':
          this.filters.from = today.clone().subtract(7, 'days').toDate();
          this.filters.to = today.toDate();
          break;
        case 'last30':
          this.filters.from = today.clone().subtract(30, 'days').toDate();
          this.filters.to = today.toDate();
          break;
        case 'last90':
          this.filters.from = today.clone().subtract(90, 'days').toDate();
          this.filters.to = today.toDate();
          break;
        case 'last365':
          this.filters.from = today.clone().subtract(365, 'days').toDate();
          this.filters.to = today.toDate();
          break;
        case 'last2years':
          this.filters.from = today.clone().subtract(730, 'days').toDate();
          this.filters.to = today.toDate();
          break;
        case 'custom':
          this.filters.from = null;
          this.filters.to = null;
          break;
        default:
          this.filters.from = null;
          this.filters.to = null;
      }
    }
  },
  watch: {
    filters: {
      handler() {
        this.emitFilters();
      },
      deep: true
    },
    userSearch(newVal) {
      if (this.userSearchDebounce) clearTimeout(this.userSearchDebounce);

      if (!newVal || newVal.length < 2) {
        this.userOptions = [];
        return;
      }

      this.userLoading = true;

      this.userSearchDebounce = setTimeout(async () => {
        const results = await this.$store.dispatch('customers/search', {
          search: newVal
        });

        this.userOptions = (results || []).map(user => ({
          _id: user._id,
          label: `${user.name} ${user.surname || ''} - ${user.email || user.phone || ''}`
        }));

        this.userLoading = false;
      }, 400);
    }
  },
  mounted() {
    this.$nextTick(() => {
      const input = this.$refs.cityInput.$el.querySelector('input');
      const options = {
        types: ['(cities)'],
        componentRestrictions: { country: 'it' }
      };

      this.cityAutocomplete = new google.maps.places.Autocomplete(input, options);
      setTimeout(() => {
        input.setAttribute('placeholder', '');
      }, 100); // 50–100ms sono sufficienti

      this.cityAutocomplete.addListener('place_changed', () => {
        const place = this.cityAutocomplete.getPlace();
        if (!place.geometry) return;

        this.filters.lat = place.geometry.location.lat();
        this.filters.lng = place.geometry.location.lng();
        this.cityLabel = place.formatted_address || place.name;
      });
    });

  },
  beforeDestroy() {
    if (this.cityAutocomplete) {
      google.maps.event.clearInstanceListeners(this.cityAutocomplete);
    }
  }

};
</script>
